<template>
    <div class="advance-audit-dialog">
        <el-dialog v-dialog-drag :title="readonly ? '认领详情' : '审核信息'" :visible.sync="showDialog" width="800px" :destroy-on-close="true"
            append-to-body :before-close="cancel" class="audit-dialog">
            <div class="el-dialog-div">
                <!-- 审核操作区域 -->
                <div class="section-card audit-section" v-if="!readonly">
                    <div class="section-header-bar">
                        <span class="section-title"><i class="el-icon-s-check"></i> 审核操作</span>
                        <el-button size="small" type="success" icon="el-icon-check" @click="handle">确认审核</el-button>
                    </div>
                    <el-form label-width="110px" ref="form" :model="form" class="audit-form">
                        <el-form-item label="审核结果" prop="status"
                            :rules="{ required: true, message: '审核结果不能为空', trigger: 'change' }">
                            <el-radio v-model="form.status" label="SUCCESS">
                                <i class="el-icon-success" style="color: #67c23a;"></i> 通过
                            </el-radio>
                            <el-radio v-model="form.status" label="DEFEAT">
                                <i class="el-icon-error" style="color: #f56c6c;"></i> 驳回
                            </el-radio>
                        </el-form-item>
                        <el-form-item label="驳回原因" prop="rejectionReason" v-if="form.status === 'DEFEAT'"
                            :rules="{ required: true, message: '驳回原因不能为空', trigger: 'change' }">
                            <el-input style="width: 100%;" type="textarea" rows="3" maxlength="300" show-word-limit
                                placeholder="请输入驳回原因" v-model="form.rejectionReason" clearable>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <!-- 认领信息详情 -->
                <div class="section-card">
                    <div class="section-header-bar" @click="toggleSection('claimInfo')">
                        <div class="section-title"><i class="el-icon-info"></i> 认领信息详情</div>
                        <i :class="sectionOpen.claimInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </div>
                    <div class="detail-grid" v-show="sectionOpen.claimInfo">
                        <div class="detail-item" v-if="selectDetail?.['annex']?.['CLAIM_THE_ADVANCE_PAYMENT_ANNEX']">
                            <span class="detail-label">认领附件</span>
                            <span class="detail-value">
                                <div class="attachment-actions">
                                    <el-button size="mini" type="primary" icon="el-icon-download" @click="download(form.id, 'CLAIM_THE_ADVANCE_PAYMENT_ANNEX')">下载</el-button>
                                    <el-button size="mini" type="primary" icon="el-icon-view" @click="preview(form.id, 'CLAIM_THE_ADVANCE_PAYMENT_ANNEX')">预览</el-button>
                                </div>
                            </span>
                        </div>
                        <div class="detail-item full-width">
                            <span class="detail-label">认领备注</span>
                            <span class="detail-value">
                                <el-input type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 3 }"
                                    v-model="selectDetail.remark" readonly>
                                </el-input>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- 垫付款信息详情 -->
                <div class="section-card">
                    <div class="section-header-bar" @click="toggleSection('advanceInfo')">
                        <div class="section-title"><i class="el-icon-money"></i> 垫付款信息详情</div>
                        <i :class="sectionOpen.advanceInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </div>
                    <div class="detail-grid" v-show="sectionOpen.advanceInfo">
                        <div class="detail-item">
                            <span class="detail-label">合同编号</span>
                            <span class="detail-value">
                                <el-link :underline="false" type="primary" @click="openContractDialog(advance.contractNumber)">{{ advance.contractNumber }}</el-link>
                            </span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">合同金额</span>
                            <span class="detail-value"><span class="amount-text">{{ advance.contractAmount }}</span></span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">付款单位</span>
                            <span class="detail-value">{{ advance.invoiceTitle }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">收款单位</span>
                            <span class="detail-value">{{ receivingUnit.find(item => Number(item.id) === Number(advance.receivingUnitId))?.name }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">垫付款金额</span>
                            <span class="detail-value"><span class="amount-text">{{ advance.paymentAmount }}</span></span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">垫付款时间</span>
                            <span class="detail-value">{{ advance.paymentDate }}</span>
                        </div>
                        <div class="detail-item full-width">
                            <span class="detail-label">垫付款备注</span>
                            <span class="detail-value">{{ advance.remark }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
       <contract-details v-if="showContractDetails" :show-dialog="showContractDetails"
            :select-detail="[ContractDetail]" @submit="close1"></contract-details>
        <tickets-details v-if="showTicketsDetails" :show-dialog="showTicketsDetails" :select-detail="TicketsDetail"
            @submit="close2"></tickets-details>
        <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
        <loading :loading="loading" load-text="提交中"></loading>
    </div>

</template>

<script>

import { getDataInLocalStorage } from "@/utils/localStorage";
import { attachmentDownload, auditInfo } from "@/api/dilivery/audit";
import { fileDownload } from "@/utils/downFileUtils";
import { getContractPage } from "@/api/dilivery/sales/contract";
import ContractDetails from "@/components/sales/ContractDetails.vue";
import FilePreview from "@/components/file/FilePreview.vue";
import Loading from "@/components/loading/Loading.vue";
const baseURL = process.env.VUE_APP_BASE_API

export default {
    name: "AdvanceAuditDialog",
    components: { FilePreview, ContractDetails, Loading },
    props: ['showDialog', 'selectDetail', 'readonly'],
    data() {
        return {
            loading: false,
            showFile: false,
            fileInfo: null,
            sectionOpen: {
                claimInfo: true,
                advanceInfo: true,
            },
            showContractDetails: false,
            ContractDetail: '',
            showTicketsDetails: false,
            TicketsDetail: '',
            advance: {},
            form: {
                id: '',
                status: '',
                rejectionReason: ''
            },
            receivingUnit: [
                {
                    id: "10",
                    name: "南京微合生物科技有限公司"
                },
                {
                    id: "9",
                    name: "成都百麦斯特生物科技有限公司"
                },
                {
                    id: "8",
                    name: "江苏凌帆生物科技有限公司"
                },
                {
                    id: "7",
                    name: "北京凌恩生物科技有限公司"
                },
                {
                    id: "6",
                    name: "上海盈飞生物科技有限公司"
                },
                {
                    id: "5",
                    name: "陕西智享凌波微课生物科技有限公司"
                },
                {
                    id: "4",
                    name: "江苏普朗睿恩生物科技有限公司"
                },
                {
                    id: "3",
                    name: "南京凌恩生物科技有限公司"
                },
                {
                    id: "2",
                    name: "杭州普朗爱锐生物科技有限公司"
                },
                {
                    id: "1",
                    name: "上海凌恩生物科技有限公司"
                }
            ]
        };
    },
    watch: {
        selectDetail: {
            handler(newVal) {
                if (newVal && Object.keys(newVal)) {
                    this.form.id = newVal.id
                    this.advance = JSON.parse(newVal.rawData)
                } else {
                    this.advance = {}
                }
            },
            immediate: true
        }
    },
    methods: {
        toggleSection(section) {
            this.sectionOpen[section] = !this.sectionOpen[section];
        },
        cancel() {
            this.$emit('submit', 'cancel')
        },
        openContractDialog(contractNumber) {
            let param = {}
            let data = {
                "query#contractNumber.EQ": contractNumber
            }
            getContractPage(param, data).then(res => {
                if (res.code === 200) {
                    if (res.records.length === 0) {
                        this.$messageUi.error("打开合同详情失败")
                    } else {
                        this.ContractDetail = res.records[0]
                        this.showContractDetails = true
                    }
                }
            }).catch(error => { })
        },
        close1() {
            this.showContractDetails = false
        },
        handle() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    auditInfo(this.form).then(res => {
                        this.loading = false
                        if (res.code === 200) {
                            this.$store.commit('right/setChangeRed', true)
                            this.$emit('submit', 'confirm')
                            if (this.form.status === 'SUCCESS') {
                                this.$messageUi.success('已通过')
                            } else {
                                this.$messageUi.success('已驳回')
                            }
                        }
                    }).catch(err => {
                        this.loading = false
                    })
                } else {
                    this.$nextTick(() => {
                        let err = document.getElementsByClassName('is-error')
                        if (err.length) {
                            err[0].scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                            })
                        }
                    })
                    this.$messageUi.error('填写参数不规范，请检查')
                }
            });
        },
        async download(id, type) {
            try {
                let url = `${baseURL}/audit-info/attachment/${id}/${type}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
            }
        },
        async preview(id, type) {
            try {
                this.fileInfo = await attachmentDownload(id, type);
                this.showFile = true
            } catch (error) {
                console.log(error);
            }
        },
        close() {
            this.showFile = false
            this.fileInfo = null
        },
    }
};
</script>

<style lang="scss" scoped>
.advance-audit-dialog {
  ::v-deep .audit-dialog {
    .el-dialog__header {
      
      padding: 15px 20px;
      
       .el-dialog__title {
        font-weight: 600;
      }
      
      
    }
    
    .el-dialog__body {
      padding: 20px;
    }
  }
}
@import "@/assets/css/mixins.scss";
@import "@/assets/css/detail.css";
.el-dialog-div {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 5px;
  
  @include thin-scrollbar(8px, #888);
}

.audit-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
}

.audit-form {
  padding: 16px;
}

</style>
